import { Link } from "react-router-dom";
import { Layout } from "../components/layout/Layout";
import { ArticleCard } from "../components/posts/ArticleCard";
import { FeaturedImage } from "../components/posts/FeaturedImage";
import { JsonLd } from "../components/seo/JsonLd";
import { SEO } from "../components/seo/SEO";
import { organizationSchema, websiteSchema } from "../components/seo/schema";
import { site } from "../data/site";
import { getPublishedPosts } from "../lib/posts";
import { categoryPath, tagPath } from "../lib/slug";
import { getCategories, getTags } from "../lib/taxonomy";

export function Home() {
  const publishedPosts = getPublishedPosts();
  const featuredPost = publishedPosts[0];
  const latestPosts = publishedPosts.slice(0, 6);
  const categories = getCategories();
  const tags = getTags().sort((a, b) => b.count - a.count).slice(0, 20);

  return (
    <Layout>
      <SEO title={`${site.name} - Wiki-Style Knowledge Blog`} description={site.description} canonical={site.url} />
      <JsonLd data={[websiteSchema(), organizationSchema()]} />

      <section className="home-hero" aria-labelledby="home-title">
        <div>
          <p className="eyebrow">Open notes for practical knowledge</p>
          <h1 id="home-title">{site.name}</h1>
          <p>{site.description}</p>
        </div>
        {featuredPost ? (
          <article className="featured-article">
            <FeaturedImage src={featuredPost.featuredImage} alt="" loading="eager" />
            <div>
              <span>Featured article</span>
              <h2>
                <Link to={featuredPost.url}>{featuredPost.title}</Link>
              </h2>
              <p>{featuredPost.excerpt}</p>
            </div>
          </article>
        ) : null}
      </section>

      <section className="section" aria-labelledby="latest-title">
        <div className="section-heading">
          <h2 id="latest-title">Latest published articles</h2>
          <span>{publishedPosts.length} public entries</span>
        </div>
        <div className="article-list">
          {latestPosts.map((post) => (
            <ArticleCard key={post.slug} post={post} />
          ))}
        </div>
      </section>

      <section className="taxonomy-grid" aria-label="Browse taxonomy">
        <div className="taxonomy-panel">
          <h2>Categories</h2>
          {categories.map((category) => (
            <Link key={category.slug} to={categoryPath(category.name)}>
              <span>{category.name}</span>
              <span>{category.count}</span>
            </Link>
          ))}
        </div>
        <div className="taxonomy-panel">
          <h2>Popular tags</h2>
          <div className="tag-cloud">
            {tags.map((tag) => (
              <Link key={tag.slug} to={tagPath(tag.name)}>
                {tag.name}
              </Link>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
